function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { pickValidValues } from '../../../helpers/components-helpers';
import { StyledTextInput } from './style';

class NumberTextInput extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "_onChange", change => {
      if (change && this.props.onChange) {
        if (isNaN(Number(change.value))) {
          return;
        } else {
          var value = change.value === '' ? null : Number(change.value);
          this.props.onChange({
            name: change.name,
            value
          });
        }
      }
    });

    _defineProperty(this, "_onBlurChange", change => {
      if (change && !isNaN(Number(change.value)) && this.props.onBlurChange) {
        var value = change.value === '' ? null : Number(change.value);
        this.props.onBlurChange({
          name: change.name,
          value
        });
      }
    });
  }

  _modifyWithDefaultOptions() {
    var {
      options
    } = this.props;
    var optionsWithValidValue = pickValidValues(options);
    return _objectSpread(_objectSpread({}, this.props), {}, {
      options: Object.assign({
        mask: '9999999999'
      }, optionsWithValidValue)
    });
  }

  render() {
    var _this$_modifyWithDefa = this._modifyWithDefaultOptions(),
        {
      onChange
    } = _this$_modifyWithDefa,
        textInputProps = _objectWithoutProperties(_this$_modifyWithDefa, ["onChange"]);

    return /*#__PURE__*/React.createElement(StyledTextInput, _extends({}, textInputProps, {
      onChange: this._onChange,
      onBlurChange: this._onBlurChange
    }));
  }

}

_defineProperty(NumberTextInput, "defaultProps", {
  options: {},
  type: 'tel'
});

export default NumberTextInput;